import { type Common } from './common.js';
import { type NoteFieldWithConfig } from './models/note/field.js';
import {
  type CreateUpdateValues,
  type DetailsResponse,
  type FindAllOptions,
  type TemplateIdentifier,
} from './models/noteTemplate.js';

export class API {
  common: Common;
  baseEndpoint: string;

  constructor(common: Common) {
    this.common = common;
    this.baseEndpoint = '/note-templates';
  }

  async findAll(options?: FindAllOptions): Promise<TemplateIdentifier[]> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    const { results } = await this.common.getJSON(url);
    return results.templates;
  }

  async findOneById(noteTemplateId: string): Promise<DetailsResponse> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${noteTemplateId}`);
    const { results } = await this.common.getJSON(url);
    return results;
  }

  async createTemplate(data: CreateUpdateValues): Promise<DetailsResponse> {
    const url = this.common.constructPath(this.baseEndpoint);
    const { results } = await this.common.postJSON(url, data);
    return results;
  }

  async updateTemplate(noteTemplateId: string, data: CreateUpdateValues): Promise<DetailsResponse> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${noteTemplateId}`);
    const { results } = await this.common.putJSON(url, data);
    return results;
  }

  async deleteTemplate(noteTemplateId: string): Promise<void> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${noteTemplateId}`);
    await this.common.deleteJSON(url);
  }

  async previsitApplyTemplate(previsitFormSetId: string): Promise<NoteFieldWithConfig[]> {
    const url = this.common.constructPath(`${this.baseEndpoint}/previsit/apply`);
    return await this.common.postJSON(url, { previsitFormSetId });
  }
}
